import { createStyles, makeStyles, Theme, interactiveLinkStyle, pressedLinkShadow } from 'ui-components';
import { fontDisplay } from 'common-react';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  sumError: {
    '& .MuiInputBase-root': {
      border: `1px solid ${theme.color.reds[100]}`,
    },
  },
  sumFundItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: 16,
      borderRadius: 0,
    },
  },
  sumFindItemText: {
    maxWidth: 456,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      borderRight: 0,
      marginBottom: 16,
    },
  },
  sumFindItemTitle: {
    marginBottom: 8,
  },
  oldFundName: {
    marginTop: 4,
  },
  titleWithChevron: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      '& svg path': {
        fill: theme.color.oranges[100],
      },
    },
  },
  sumFindItemValue: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      maxWidth: '100%',
      width: '100%',
      gap: 10,
    },
  },
  deleteButton: {
    position: 'relative',
    top: 40,
    background: 'none',
    border: 0,
    padding: 0,
    color: theme.color.oranges[50],
    cursor: 'pointer',
    width: 24,
    height: 24,
    transition: 'background-color 0.150s ease-in-out',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.color.greys[10],
    }
  },
  formControl: {
    marginRight: 24,
    maxWidth: 225,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      maxWidth: '100%',
      width: '100%',
    },
  },
  inputLabel: {
    font: fontDisplay('normal', theme.fontSize.s, 16),
    color: theme.color.greys[80],
    marginBottom: 8,
  },
  button: {
    '&:hover': {
      cursor: 'pointer',
      '& $text': {
        ...interactiveLinkStyle(theme),
      },
      '& $icon path': {
        fill: theme.color.violets[100],
      },
    },
    '&:active': {
      '& $textWrapper': {
        backgroundColor: pressedLinkShadow,
      },
    },
  },
  textWrapper: {},
  text: {},
  icon: {},
}), {name: 'SetAmountsFundBox'});
